// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_98-0";
export var orangeButton = "_98-1";